import { useMutation, useQueryClient } from '@tanstack/react-query';

const THREADS_QUERY_KEY = ['AI'];

/**
 * Hook to remove a thread from the cache
 * @param agentName - The agent ID
 * @param resourceId - The resource ID or user ID
 * @returns Mutation function to remove optimistic thread
 */
export const useRemoveThread = ({ agentName, resourceId }: { agentName: string; resourceId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ threadId }: { threadId: string }) => {
      const queryKey = [...THREADS_QUERY_KEY, agentName, resourceId];

      // // Remove the optimistic thread from the cache
      // queryClient.setQueryData(queryKey, (oldData: StorageThreadType[] | undefined) => {
      //   if (!oldData) return oldData;

      //   return oldData.filter((thread: StorageThreadType) => thread.id !== threadId);
      // });
    },
  });
};
